import usersSlice from "./slices/usersSlice"
import homeSlice from "./slices/homeSlice"
import rolesAndPermissionSlice from "./slices/rolesAndPermissionSlice"
import entitySlice from "./slices/entitySlice"
import masterSlice from "./slices/masterSlice"
import pendingByApproverSlice from "./slices/pendingByApproverSlice"
import userDetailsSlice from "./slices/userDetailsSlice"
import receiptWalletSlice from "./slices/receiptWalletSlice"
import ccSlice from "./slices/ccSlice"
import approverSlice from "./slices/approverSlice"
import accountsSlice from "./slices/accountsSlice"
import userAccountSlice from "./slices/userAccountSlice"
import globalSlice from "./slices/globalSlice"
import projectsSlice from "./slices/projectsSlice"
import locationsSlice from "./slices/locationSlice"
import triggerSlice from "./slices/triggerSlice"
import formSlice from "./slices/formSlice"
import teamSlice from "./slices/teamSlice"
import taskSlice from "./slices/taskSlice"
import reportSlice from "./slices/reportSlice"
import loadingReducer from "./slices/loadingSlice"
import scoreSlice from "./slices/scoringSlice"
import notificationSlice from "./slices/notificationSlice"
import announcementSlice from "./slices/announcementSlice"
import trainingSlice from "./slices/trainingSlice"
const rootReducer = {
    global: globalSlice,
    form: formSlice,
    report: reportSlice,
    users: usersSlice,
    home: homeSlice,
    notification: notificationSlice,
    score: scoreSlice,
    rolesAndPermission: rolesAndPermissionSlice,
    // entity: entitySlice,
    // master:masterSlice,
    // pendingByApprover: pendingByApproverSlice,
    userDetails: userDetailsSlice,
    // receiptWallet: receiptWalletSlice,
    // cc: ccSlice,
    // approver: approverSlice,
    // accounts: accountsSlice,
    userAccount: userAccountSlice,
    projects: projectsSlice,
    locations: locationsSlice,
    team: teamSlice,
    task: taskSlice,
    trigger: triggerSlice,
    loading: loadingReducer,
    announcement: announcementSlice,
    training: trainingSlice
}

export default rootReducer